import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Get Help - Resources (English) Page
const ResourcesEnglishPage = () => {
  const resources = [
    "Emergency Medical Care & Hospital Services",
    "Primary Medical Care",
    "Mental Health Services",
    "Dental Care",
    "Vision Care",
    "Legal Assistance: Housing, Family, Employment, Protection from Abuse, Immigration",
    "SNAP",
    "WIC",
    "Child Care Assistance",
    "English Classes (ESL)",
    "Emergency Medicaid",
    "Early Childhood Intervention Services",
    "School Enrollment Assistance"
  ];

  return (
    <div data-testid="resources-english-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/xwp39obs_Resources.jpg"
        alt="Community Resources"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="resources-english-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Resources
            </h1>
            
            <p className="text-[#666666] text-base md:text-lg leading-relaxed mb-10">
              Murphy's Giving Market may be able to help connect you with community resources in the following areas. Availability and eligibility are determined by each organization, and Murphy's Giving Market cannot guarantee services or outcomes. Please contact us for more information.
            </p>
            
            <div className="space-y-3">
              {resources.map((resource, index) => (
                <motion.div
                  key={resource}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-2 h-2 bg-[#C41E3A] rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-[#1A1A1A] text-base md:text-lg">{resource}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesEnglishPage;
